import {
  getAllWordpressPageDataById,
  getWordpressPageById,
} from "../../api/wordpress";

import useAwaitedValue from "./useAwaitedValue";

/**
 * Get the wordpress HTML of a particular page
 *
 * @param id page id
 * @returns html string
 */
export const useWordpressPage = (id: number) =>
  useAwaitedValue(
    "",
    () =>
      getWordpressPageById(id).catch(() => {
        // if page doesn't exist, go to error 404 page
        window.location.replace("https://www.duolingo.com/errors/404.html");
      }),
    [],
  );

/**
 * Get all data for wordpress page
 *
 * @param id page id
 * @returns Object
 */
export const useWordpressPageAllData = (id: number) =>
  useAwaitedValue(
    {},
    () =>
      getAllWordpressPageDataById(id).catch(() => {
        // if page doesn't exist, go to error 404 page
        window.location.replace("https://www.duolingo.com/errors/404.html");
      }),
    [],
  );
